export default __webpack_public_path__ + "static/media/INXC.ef1057c6.png";